import { formatZip, sortDates, formatDate, getCookie, cleanPhoneNumber } from './modules/utils.js';
import { findCenters, times4Center, loginHome, bookAppt, reschedule, schedulePreop, preflight, verifyEmail, verifyPhone } from './modules/api.js';
import { initLocationMap } from './modules/map.js';
import { initTooltips } from './modules/tooltips.js';
import { ischeduleData } from './modules/data.js';
import { formatDistanceText, getBrandName, getBrandImageHTML, createCenterHTML } from './modules/centers.js';
import { getUserLocation, getZipCodeFromCoordinates } from './modules/geolocation.js';

jQuery(document).ready(function ($) {	

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Variables
	
	// Exit early if data couldn't be loaded
	if (!ischeduleData) {
		return;
	}

	// Variables
	const ischedule = $(".isched");
	let centers = [];
	let selected_center = null;
	let email_changed = true;
	let phone_changed = true;

	// brand full name
	let brandFullName = 'LASIK.com';
	if (ischeduleData.brand === 'lvi') {
		brandFullName = 'The Lasik Vision Institute';
	} else if (ischeduleData.brand === 'lp') {
		brandFullName = 'Lasik<em>Plus</em>';
	} else if (ischeduleData.brand === 'tlc') {
		brandFullName = 'TLC Laser Eye Centers';
	} else if (ischeduleData.brand === 'wht') {
		brandFullName = 'Whiting Clinic';
	}

	
	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Log DEV or PROD

	if (ischeduleData.isDev) {
		console.log('DEV ');
	}	else {
		console.log('PROD');
	}

	
	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Send preflight data (background call - errors don't break flow)

	function sendPreflightData() {
		// Collect available preflight data
		const preflightParams = {
			fname: ischeduleData.fname,
			lname: ischeduleData.lname,
			email: ischeduleData.email,
			dob: ischeduleData.dob,
			areaCode: ischeduleData.areaCode,
			phoneNo: ischeduleData.phoneNo,
			centerCode: ischeduleData.centerCode,
			apptDate: ischeduleData.apptDate,
			apptTime: ischeduleData.apptTime,
			consultType: ischeduleData.consultationType === 'in-center' ? 'in-person' : ischeduleData.consultationType, // convert "in-center" to "in-person" for API
			zipPostal: ischeduleData.zipCode,
			brand: ischeduleData.brand,
			encSource: ischeduleData.encSource,
			isDev: ischeduleData.isDev
		};

		// Only send if we have at least email
		if (!preflightParams.email) {
			//console.log('Skipping preflight - insufficient data');
			return;
		}

		//console.log('Sending preflight data:', preflightParams);

		// Send preflight request (fire and forget - don't block on errors)
		preflight(preflightParams)
			.done(function(response) {
				//console.log('Preflight success:', response);

				// Send Slack notification with success details
				// sendSlackWebhookAlert('✅ Preflight Success', {
				// 	requestData: preflightParams,
				// 	response: response,
				// 	timestamp: new Date().toISOString()
				// });
			})
			.fail(function(xhr, status, error) {
				console.log('Preflight failed:', error);

				// Send Slack notification with failure details
				sendSlackWebhookAlert('❌ Preflight Failed', {
					requestData: preflightParams,
					error: error,
					status: xhr.status,
					statusText: xhr.statusText,
					responseText: xhr.responseText,
					timestamp: new Date().toISOString()
				});
			});
	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Send Slack webhook alert

	function sendSlackWebhookAlert(message, rules = null) {
		// Use WordPress REST API endpoint
		const restUrl = typeof IScheduleData !== 'undefined' ? IScheduleData.restUrl : '/wp-json/ischedule/v1';
		const endpoint = `${restUrl}/sendSlackAlert`;

		// Build the payload
		const payload = {
			message: message,
			data: rules || null
		};

		// Send the request
		$.ajax({
			url: endpoint,
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(payload),
			success: function() {
				//console.log('Slack notification sent');
			},
			error: function(xhr, status, error) {
				//console.error('Failed to send Slack notification:', error);
			}
		});
	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Log errors and redirect to default error confirmation page

	function error_redirect(msg) {
		console.log(msg);
		
		// Send Slack notification with error details
		const errorData = {
			message: msg,
			url: window.location.href,
			userAgent: navigator.userAgent,
			timestamp: new Date().toISOString(),
			ischeduleData: ischeduleData
		};
		sendSlackWebhookAlert('iSchedule Error: ' + msg, errorData);
		
		if (ischeduleData.isDev) {
			alert('error_redirect: ' + msg);
			console.warn(JSON.stringify(msg));
			window.location.href = ischeduleData.errorUrl;
		} else {
			// Send Slack notification with failure details
			sendSlackWebhookAlert('❌ Error Redirect', {
				message: msg,
				url: window.location.href,
				userAgent: navigator.userAgent,
				timestamp: new Date().toISOString(),
				ischeduleData: ischeduleData
			});
			// Redirect to error page
			window.location.href = ischeduleData.errorUrl;
		}
	}

	
	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// showStep
  
	function showStep(step) {
		//console.log(`showStep("${step}")`);
		console.log(ischeduleData);
	
		$(".isched__step").removeClass("active"); // Hide all
		$(`[data-step="${step}"]`).addClass("active"); // Show selected
		
		// Scroll to top of page
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}


	function changeConsultationType(type) {
		spinner();
		ischeduleData.consultationType = type;
		getCentersFromZip();
	}


	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Let's Go!
	
	spinner();

	if (ischeduleData.clientToken) {
		userLookup();
	} else {
		start();
	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// startForm

	function start() {
		showStep("start");

		const $startForm = $(".isched_start__form");

		// Use click handler to show spinner immediately before Parsley intercepts
		$startForm.off('click', 'button[type="submit"]').on('click', 'button[type="submit"]', function(e) {
			e.preventDefault();
			
			// Show spinner immediately
			spinner('Finding your nearest Vision Centers...');
			
			// Use whenValidate() which validates AND shows errors
			$startForm.parsley().whenValidate().then(function() {
				// Form is valid - proceed
				ischeduleData.zipCode = $startForm.find('input[name="zip"]').val();
				ischeduleData.email = $startForm.find('input[name="email"]').val();
				ischeduleData.consultationType = $startForm.find('input[name="consultation_type"]:checked').val();
				populateZipValue(ischeduleData.zipCode);

				// Send preflight data
				sendPreflightData();

				getCentersFromZip();
			}).catch(function() {
				// Form is invalid - go back to start form, errors are now visible
				showStep("start");
			});
		});
	}


	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// userLookup:  if clientToken parameter is present

  	function userLookup() {
		//("userLookup()");

		loginHome(ischeduleData.clientToken, ischeduleData.isDev)
			.done(function(response) {
				//console.log(response);
				
				if (response.validationErrors) {
					error_redirect("userLookup validationErrors");
				}
		
				response = response.data;

				// Preserve original brand before copying patientInfo
				const originalBrand = ischeduleData.brand;

				// add response.patientInfo to ischeduleData
				for (var item in response.patientInfo) {
					ischeduleData[item] = response.patientInfo[item];
				}

				// Restore original brand if it was set
				if (originalBrand) {
					ischeduleData.brand = originalBrand;
				}
				
				// set consultation type
				if (response.appointmentInfo.isVirtual === 1) {
					ischeduleData.consultationType = 'virtual';
				} else {
					ischeduleData.consultationType = 'in-center';
				}
		
				// determine bookingType
				if (response.appointmentInfo && response.appointmentInfo.allowReschedule == "Y") {
					
					ischeduleData.bookingType = "reschedule";
					ischeduleData.apptId = response.appointmentInfo.apptId;
					ischeduleData.zipCode = response.patientInfo.zipCode;

				} else if (response.patientInfo && response.patientInfo.allowPreop == "Y") {
					
					ischeduleData.bookingType = "schedulePreop";
					ischeduleData.zipCode = response.patientInfo.zipCode;

				} else {
					error_redirect("User not allowed to reschedule or schedule pre-op appointment");
				}
			
				// get centers or zip
				if (ischeduleData.zipCode) {
					getCentersFromZip();
				} else {
					start(); // get zip
				}
				
			})
			.fail(function(err) {
				console.error('Failed to fetch login home:', err);
			});
  	}


	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// userlookup: run if user has clientToken or pIdH+pId

	function findZipFromCenterCode(centerCode) {
		//console.log("findZipFromCenterCode()");

		times4Center(centerCode, ischeduleData.isDev)
			.done(function(results) {

				//console.log(results);

				ischeduleData.zipCode = results.data.centerInfo.zip;
				getCentersFromZip();

			})
			.fail(function(err) {
				console.error('findZipFromCenterCode error: Failed to fetch times4Center:', err);
			});
	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// noResults

	function noResults() {
		//console.log("noResults()");

		// Clear the zip input
		$(".isched_noresults__form").find('input[name="zip"]').val('');

		// clear existing errors
		$(".isched_noresults__form").parsley().reset();

		showStep("noresults");

		// Focus the zip input
		$(".isched_noresults__form").find('input[name="zip"]').focus();
	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// No Results Form

	$(".isched_noresults__form").on('submit', function(e) {
		e.preventDefault();
		if ($(this).parsley().isValid()) {
			ischeduleData.zipCode = $(this).find('input[name="zip"]').val();
			populateZipValue(ischeduleData.zipCode);
			getCentersFromZip();
		}
	});


	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// spinner

	function spinner(message) {
		//console.log("spinner()", message);
		$(".isched_spinner__message").text(message);
		showStep('spinner');
	}


	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Helper function to check if a center matches the brand
	
	function isInBrandCenter(center) {
		if (!ischeduleData.brand) {
			return true; // No brand specified, treat all as in-brand
		}
		
		let centerBrands = [];
		if (center.associatedBrands && Array.isArray(center.associatedBrands)) {
			centerBrands = centerBrands.concat(center.associatedBrands);
		}
		if (center.brand) {
			centerBrands.push(center.brand);
		}
		if (center.brands && Array.isArray(center.brands)) {
			centerBrands = centerBrands.concat(center.brands);
		}
		
		return centerBrands.includes(ischeduleData.brand);
	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// getCentersFromZip: gets all locations within 4000 miles of zip
	
	function getCentersFromZip() {
		//console.log("getCentersFromZip()", ischeduleData.zipCode);
	
		populateZipValue(ischeduleData.zipCode);
	
		// Spinner copy
		if (ischeduleData.consultationType === 'virtual') {
			spinner('Checking availability...');
		} else {
			spinner('Finding your nearest Vision Centers...');
		}
	
		findCenters({
			zip: ischeduleData.zipCode,
			dist: '4000',
		})
			.done(function(results) {
				// Handle API "no results" shape
				if (results && results.success === "false") {
					noResults();
					return;
				}
	
				// Normalize to array
				const allCenters = Array.isArray(results) ? results : [];
	
				if (!allCenters.length) {
					noResults();
					return;
				}
	
				// Sort all centers by distance (closest first)
				allCenters.sort((a, b) => {
					const distA = parseFloat(a.distance);
					const distB = parseFloat(b.distance);
					const aVal = Number.isFinite(distA) ? distA : Infinity;
					const bVal = Number.isFinite(distB) ? distB : Infinity;
					return aVal - bVal;
				});
	
				// Build displayedCenters (max 4):
				// 1. Prioritize in-brand centers within 10 miles
				// 2. Fill remaining spots with closest centers
				const displayedCenters = [];
				const usedCenters = new Set();
	
				// First pass: add in-brand centers within 10 miles
				for (const center of allCenters) {
					if (displayedCenters.length >= 4) break;
					const distance = parseFloat(center.distance);
					if (isInBrandCenter(center) && Number.isFinite(distance) && distance <= 10) {
						displayedCenters.push(center);
						usedCenters.add(center);
					}
				}
	
				// Second pass: fill remaining spots with closest centers
				for (const center of allCenters) {
					if (displayedCenters.length >= 4) break;
					if (!usedCenters.has(center)) {
						displayedCenters.push(center);
					}
				}
	
				if (!displayedCenters.length) {
					noResults();
					return;
				}
	
				//console.log('Final displayedCenters:', displayedCenters.length, displayedCenters);
	
				// Virtual: auto-pick the first center and go to availability
				if (ischeduleData.consultationType === 'virtual') {
					selected_center = displayedCenters[0];
					setSelectedCenter(selected_center);
					getAvailability();
					return;
				}
	
				// In-center: show the centers
				showCenters(displayedCenters);
			})
			.fail(function(err) {
				console.error('Failed to fetch centers:', err);
				noResults();
			});
	}
	


	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Helper functions for center display

	// populateZipValue
	function populateZipValue(zipCode) {
		$(".isched_populate_zip_value").text(zipCode);
	}


	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// showCenters
	
	function showCenters(displayedCenters) {
		//console.log('showCenters()', displayedCenters);
		showStep("centers");
		
		// Clear existing centers list
		$(".isched_centers__list").empty();

		// Check for affiliate centers and in-brand within 10 miles for header logic
		const hasAffiliateCenters = displayedCenters.some(center => !isInBrandCenter(center));
		const hasInBrandCenters = displayedCenters.some(center => isInBrandCenter(center));
		const hasInBrandWithin10 = displayedCenters.some(center => {
			const distance = parseFloat(center.distance);
			return isInBrandCenter(center) && !isNaN(distance) && distance <= 10;
		});

		// Add affiliate header if there are affiliate centers
		if (hasAffiliateCenters) {
			let affiliateDescription;
			
			if (hasInBrandWithin10) {
				affiliateDescription = `${brandFullName} has a location near zip code ${ischeduleData.zipCode}, but as we are an official LASIK.com Network Provider, you are also seeing other LASIK.com Network Provider locations as they may be more convenient for you.`;
			} else if (hasInBrandCenters) {
				affiliateDescription = `${brandFullName} does not currently have a location near zip code ${ischeduleData.zipCode}, but as we are an official LASIK.com Network Provider, you are seeing other LASIK.com Network Provider locations closer to you.`;
			}

			if (affiliateDescription) {
				$(".isched_centers__list").append(`
					<li class="isched_centers__section_header affiliate-header">
						<div class="affiliate-header__description">${affiliateDescription}</div>
					</li>
				`);
			}
		}

		// Display all centers in order
		displayedCenters.forEach(function(center) {
			const isAffiliate = !isInBrandCenter(center);
			const centerHTML = createCenterHTML(center, ischeduleData.pluginUrl, isAffiliate, false, true, false);
			$(".isched_centers__list").append(centerHTML);
		});

		// Add click handler for center selection
		$(".center-select-btn").off("click").on("click", function() {
			const centerCode = $(this).data("center-code");
			const selectedCenter = displayedCenters.find(c => c.centerCode === centerCode);
			
			if (selectedCenter) {
				selected_center = selectedCenter;
				setSelectedCenter();
			}
		});

		// Show "too far" message if closest center is more than 50 miles away
		// (centers are already sorted by distance, so first one is closest)
		const closestCenter = displayedCenters[0];
		if (closestCenter && parseFloat(closestCenter.distance) > 50) {
			$(".isched_centers__too_far").show();
		} else {
			$(".isched_centers__too_far").hide();
		}

		// Initialize the map
		if (displayedCenters.length > 0) {
			const locationsData = displayedCenters.map(center => ({
				lat: parseFloat(center.lat),
				lng: parseFloat(center.lon),
				title: `${center.city}, ${center.state}`,
				address: center.address1,
				address_2: center.address2 || '',
				city: center.city,
				state: center.state,
				zip: center.zipPostal,
				rating: center.ratings || null,
				userRatingsTotal: center.userRatingsTotal || null,
				distance: center.distance || null,
				centerCode: center.centerCode,
				link: '#',
				brand: center.brand || ''
			}));

			window.locationsData = locationsData;
			window.ischeduleData = ischeduleData;
			
			function waitForGoogleMaps() {
				if (window.google && window.google.maps) {
					initLocationMap();
				} else {
					setTimeout(waitForGoogleMaps, 100);
				}
			}
			waitForGoogleMaps();
		}
	}

	
	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// setSelectedCenter
	
	function setSelectedCenter() {
		
		//console.log('setSelectedCenter(): ', selected_center);
		
		ischeduleData.centerCode = selected_center.centerCode;

		$('.isched_apt_details__group').hide();
		$('.isched_datetime__footer__switch_link').hide();
		if (ischeduleData.consultationType === 'virtual') {
			$('.isched_apt_details__virtual').show();
			$('.isched_datetime__footer__switch_link--in-center').show();
		} else {
			$('.isched_apt_details__in-center').show();
			$('.isched_datetime__footer__switch_link--virtual').show();
		}
			
		// populate selected center info
		$(".populate_selected_center_address").html("<div>" + selected_center.address1 + ", " + selected_center.city + ", " + selected_center.state + " " + selected_center.zipPostal + "</div>");
		$(".populate_selected_center_city").html(selected_center.city);
		$(".populate_selected_center_state").html(selected_center.state);
		
		// populate distance
		if (!selected_center || !selected_center.distance) {
			$(".populate_selected_center_distance").html("");
			//return;
		}
		// Parse the distance (assuming it comes as a number or string)
		let distance = parseFloat(selected_center.distance);
		if (isNaN(distance)) {
			$(".populate_selected_center_distance").html("");
			//return;
		}
		// Format the distance
		let formattedDistance;
		if (distance < 1) {
			// For distances less than 1 mile, show one decimal place
			formattedDistance = distance.toFixed(1) + "mi.";
		} else {
			// For distances 1 mile or more, show whole numbers
			formattedDistance = Math.round(distance) + "mi.";
		}
		// Display the distance in parentheses
		$(".populate_selected_center_distance").html("(" + formattedDistance + ")");

		
		// change location name for Whiting Clinic
		if (selected_center.centerCode === "WHTStLouisPark") {
			$(".isched__center_name").text("Whiting Clinic");
		}

		// populate selected center HTML
		$(".isched_populate_selected_center").html(createCenterHTML(selected_center, ischeduleData.pluginUrl, false, true, true, false));

		// Send preflight data
		sendPreflightData();

		getAvailability();

	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	/// In your getAvailability function, store dateTimes and virtualDateTimes in global variables or component-level variables so that populateTimes can see them.

	// getAvailability: globally accessible function to reload availability and show datetime step
	window.getAvailability = function() {
	  //console.log("getAvailability()");
	
	  if (!selected_center) {
		console.warn('No selected center found');
		return;
	  }
	

		spinner('Checking availability...');
	
	  times4Center(ischeduleData.centerCode, ischeduleData.isDev)
		.done(function(results) {
		  //console.log("times4Center:", results);
		  
		  // Store dateTimes and virtualDateTimes in a global or higher scope variable
		  window._dateTimes = results.data.dateTimes || [];
		  window._virtualDateTimes = results.data.virtualDateTimes || [];

		  // conditional to hide/show live consults
		  const $live_consult_html = $('.isched__live_consult');
		  $live_consult_html.hide();

		  // show live-virtual-consult ONLY if rtcApptTime == 'now'
		  if (results.data.rtcInfo && results.data.rtcInfo.rtcApptTime == 'now') {
			$live_consult_html.show();
		  }


		  //////////////////////////////////////////////////////////////////////////////////////////////////
		  /// Live Virtual Consult
	  
		  $('#isched_live_consult').off('click').on('click', function(e) {
			  e.preventDefault();
			  ischeduleData.apptTime = results.data.rtcInfo.rtcApptTime;
			  ischeduleData.apptDate = results.data.rtcInfo.rtcApptDate;
			  ischeduleData.consultationType = 'virtual';
			  showForm();
		  });
	
		  // Now build the list of "enabled dates" for the datepicker:
		  populateDates(window._dateTimes, window._virtualDateTimes);
		})
		.fail(function() {
		  error_redirect("getAvailability error");
		});
	}
	
	
	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// populateDates
	// if ischeduleData.consultationType == 'in-center', use dateTimes
	// if ischeduleData.consultationType == 'virtual', use virtualDateTimes
	
	function populateDates(dateTimes, virtualDateTimes) {
	  //console.log("populateDates()", dateTimes, virtualDateTimes);
	
	  let enabled_dates = [];
	  
	  // Decide which array to use based on consultType
	  const arrayToUse = (ischeduleData.consultationType === 'virtual')
		? virtualDateTimes
		: dateTimes;
	  
	  // Collect all available dates from the chosen array
	  arrayToUse.forEach(item => {
		// e.g. "MM/DD/YYYY"
		let [month, day, year] = item.date.split('/');
		let reformat = new Date(year, month - 1, day).toLocaleDateString('en-US');
		enabled_dates.push(reformat);
	  });
	
	  enabled_dates = sortDates(enabled_dates);
	
	  buildCalendar(enabled_dates);
	}

	  
	//////////////////////////////////////////////////////////////////////////////////////////////////
	/// Build the datepicker. On date selection, call populateTimes with the chosen date.

	function buildCalendar(enabled_dates) {
		//console.log("buildCalendar()", enabled_dates);

		$(".isched_datepicker").html('').datepicker("destroy");

		$(".isched_datetime__times").empty();
		$(".isched_datetime__times_col").removeClass("active");

		// if no dates, show "no availability" message
		if (enabled_dates.length === 0) {
			$('.isched_datepicker').datepicker('destroy').html('<div class="isched_datetime__no_availability">This vision center currently has no available upcoming appointment slots. Please <span class="isched_datetime__no_availability__change_center">choose another center</span> or call <a href="tel:'+ ischeduleData.defaultPhone + '">'+ ischeduleData.defaultPhone + '</a> to book over the phone.</div>');
			$('.isched_datetime__no_availability__change_center').off('click').on('click', function() {
				showStep("centers");
			});
			showStep("datetime");
			return;
		}

		let first_date = enabled_dates[0];
		let last_date = enabled_dates[enabled_dates.length - 1];

		$(".isched_datepicker").datepicker({
			maxViewMode: 0,
			startDate: first_date,
			endDate: last_date,
			beforeShowDay: function(date) {
				// Enable only the dates that match your enabled_dates array
				return {
					enabled: enabled_dates.includes(formatDate(date)), // formatDate as "M/D/YYYY"
					content: '<span class="datepicker_day_wrapper"><span class="datepicker_day_number">' + date.getDate() + '</span><i></i></span>'
				};
			},
			format: "m/d/yyyy",
			templates: {
				leftArrow: '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="m30.1 256 17-17L207 79l17-17 33.9 34-17 17-143 143L241 399l17 17-34 33.9-17-17L47 273l-17-17z"/></svg></div>',
				rightArrow: '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="m289.9 256-17 17L113 433l-17 17-33.9-34 17-17 143-143L79 113 62 96l34-33.9 17 17L273 239l17 17z"/></svg></div>'
			},
		});

		// Show the date/time step
		showStep("datetime");

		// When a date is picked in the datepicker
		$(".isched_datepicker").off("changeDate").on("changeDate", function(e) {

			// Store the date as a string in "M/D/YYYY" format for API calls
			const selectedDate = new Date(e.date);
			ischeduleData.apptDate = selectedDate.toLocaleDateString("en-US"); // "M/D/YYYY"

			// Format nicely for display (e.g. "Sunday, January 1")
			const dateFormatOptions = { weekday: "long", month: "long", day: "numeric" };
			const selectedDateFormatted = selectedDate.toLocaleDateString("en-US", dateFormatOptions);

			$(".isched_populate_selected_date").text(selectedDateFormatted);

			// Now populate times for that date
			populateTimes(ischeduleData.apptDate);

			// Scroll to times column after content is populated (mobile only)
			if (window.innerWidth < 768) {
				setTimeout(() => {
					const $timesCol = $('.isched_datetime__times_col');
					if ($timesCol.length && $timesCol.offset()) {
						const scrollPosition = $timesCol.offset().top - 100; // 100px from top
						window.scrollTo({
							top: scrollPosition,
							behavior: 'smooth'
						});
					}
				}, 50);
			}
		});
	}


	//////////////////////////////////////////////////////////////////////////////////////////////////
	/// Finally, the populateTimes function looks at your global dateTimes and virtualDateTimes,
	/// finds times for the chosen date, and appends them to the .available_times container.
	///  @param {string} selectedDateStr - The user-selected date in "M/D/YYYY" format.

	function populateTimes(selectedDateStr) {
		//console.log("populateTimes()", selectedDateStr);

		// Clear the .isched__times container and show the time columns
		$(".isched__times").empty();
		$(".isched_datetime__times_col").addClass("active");

		// Determine which array of date/times to use (virtual vs. in-center)
		const arrayToUse = (ischeduleData.consultationType === 'virtual') ?
			window._virtualDateTimes :
			window._dateTimes;

		// Filter the times for the selected date
		let timesForSelectedDate = [];
		if (arrayToUse && arrayToUse.length) {
			const found = arrayToUse.find(item => item.date === selectedDateStr);
			if (found && found.times) {
				timesForSelectedDate = found.times;
			}
		}

		// If no times found, show a fallback message
		if (!timesForSelectedDate.length) {
			$(".isched__times").html("<div>No available times for this date.</div>");
			return;
		}

		// Build out each timeslot, including a Next button from the start
		timesForSelectedDate.forEach(time => {

			const timeSlotHTML = `
		  <div class="isched_timeslot">
			<button
			  class="isched_timeslot__time"
			  data-time="${time}"
			>
			  ${time}
			</button>
			<button
			  class="isched_timeslot__next"
			  data-time="${time}"
			>
			  Select
			</button>
		  </div>
		`;
			$(".isched__times").append(timeSlotHTML);
		});


		// on .isched_timeslot__time click
		$(".isched__times")
			.off("click", ".isched_timeslot__time") // unbind any previous handlers
			.on("click", ".isched_timeslot__time", function() {
				$(".isched_timeslot").removeClass("selected");
				// Add "selected" to the clicked timeslot's parent
				$(this).closest(".isched_timeslot").addClass("selected");
			})

			// on .isched_timeslot__next click
			.off("click", ".isched_timeslot__next")
			.on("click", ".isched_timeslot__next", function() {
				// You can retrieve the time if needed:
				ischeduleData.apptTime = $(this).data("time");

				$('.isched_populate_selected_time').text(ischeduleData.apptTime);

				// Send preflight data
				sendPreflightData();

				// Proceed to your form step
				showForm();
			});
	}
	
	
	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// changeConsultationType - globally accessible function to change consultation type

	window.changeConsultationType = function(type) {
		changeConsultationType(type);
		return false;
	}
	
	//////////////////////////////////////////////////////////////////////////////////////////////////
	/// showForm
	
	function showForm() {

		const $form = $('#isched_form');

		if (ischeduleData.firstName) {
			$form.find('input[name="firstName"]').val(ischeduleData.firstName);
		}
		if (ischeduleData.lastName) {
			$form.find('input[name="lastName"]').val(ischeduleData.lastName);
		}
		if (ischeduleData.email) {
			$form.find('input[name="email"]').val(ischeduleData.email);
		}
		if (ischeduleData.phoneAreaCode && ischeduleData.phoneNumber) {
			$form.find('input[name="phone"]').val(ischeduleData.phoneAreaCode + ischeduleData.phoneNumber);
		}
		if (ischeduleData.birthDate) {
			$form.find('input[name="dob"]').val(ischeduleData.birthDate);
		}

		//console.log('showForm()');

		showStep('form');

		// clear existing errors
		$form.parsley().reset();

		// reset button text
		$('.isched-button__text').hide();
		$('.isched-button__text--default').show();

		// show/hide consultation type details
		$('.isched_apt_details__group').hide();
		if (ischeduleData.consultationType === 'virtual' && ischeduleData.apptTime == 'now') {
			$('.isched_apt_details__live').show();
		} else if (ischeduleData.consultationType === 'in-center') {
			$('.isched_apt_details__in-center').show();
		} else if (ischeduleData.consultationType === 'virtual') {
			$('.isched_apt_details__virtual').show();
		}

		if (ischeduleData.apptTime == 'now') {
			$('.isched_apt_details__now').show();
			$('.isched-button__text').hide();
			$('.isched-button__text--now').show();
		}

		// Match start form behavior:
		// - show spinner on button click (before Parsley intercepts)
		// - validate (including verifyemail/verifyphone) via whenValidate()
		// - submit only if valid; otherwise return to form step
		const attemptFormSubmit = function(e) {
			e.preventDefault();

			// Show spinner immediately
			spinner('Scheduling your consultation...');

			// Use whenValidate() which validates AND shows errors
			$form.parsley().whenValidate().then(function() {
				// Form is valid - proceed
				ischeduleData.fname = $form.find('input[name="firstName"]').val();
				ischeduleData.lname = $form.find('input[name="lastName"]').val();
				ischeduleData.email = $form.find('input[name="email"]').val();
				ischeduleData.dob = $form.find('input[name="dob"]').val();
				ischeduleData.phone = $form.find('input[name="phone"]').val();
				ischeduleData.company_url = $form.find('input[name="company_url"]').val();

				// Clean phone number and extract area code/phone number
				const cleanPhone = cleanPhoneNumber(ischeduleData.phone);
				ischeduleData.areaCode = cleanPhone.substring(0, 3); // First 3 digits (area code)
				ischeduleData.phoneNo = cleanPhone.substring(3); // Remaining digits

				// preferred_contact_method
				// const checkedContactMethods = $(this).find('input[name="preferred_contact_method[]"]:checked').map(function() {
				// 	return $(this).val();
				// }).get();
				// ischeduleData.contactMethods = checkedContactMethods.length > 0 ? checkedContactMethods.join(',') : '';

				if ($form.find('[name="smsOptin"]').is(":checked")) {
					ischeduleData.smsOptin = "Y";
				} else {
					ischeduleData.smsOptin = "N";
				}

				formSubmit();
			}).catch(function() {
				// Form is invalid - go back to form, errors are now visible
				showStep('form');
			});
		};

		// Remove any existing handlers first to prevent duplicates
		$form.off('click', 'button[type="submit"]');
		$form.off('submit');

		// Click handler shows spinner immediately (like start form)
		$form.on('click', 'button[type="submit"]', attemptFormSubmit);

		// Support enter-to-submit as well (no click event)
		$form.on('submit', attemptFormSubmit);

	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// formSubmit

	function formSubmit() {
		//console.log('formSubmit()');

		ischeduleData.language = "";

		// Send final preflight
		sendPreflightData();

		// BOOKING TYPE
		// ischeduleData.bookingType can be bookAppt, reschedule, or schedulePreop
		// Default to bookAppt if not set (for regular new appointments)
		if (!ischeduleData.bookingType) {
			ischeduleData.bookingType = "bookAppt";
		}

		//console.log('bookingType:', ischeduleData.bookingType);
		//console.log('formData:', ischeduleData);

		// Build trackers object (matching form_process.php structure)
		const trackers = {};
		
		// Get uid from cookie or ischeduleData
		const uid = getCookie('uid') || getCookie('user_uid');
		if (uid) trackers.uid = uid;
		
		// Get domain from current location
		const domain = window.location.hostname;
		if (domain) trackers.domain = domain;
		
		// Get user agent
		const user_agent = navigator.userAgent;
		if (user_agent) trackers.user_agent = user_agent;
		
		// Add employeeRefId and offerCode if available
		if (ischeduleData.employeeRefId) trackers.employeeRefId = ischeduleData.employeeRefId;
		if (ischeduleData.offerCode) trackers.offerCode = ischeduleData.offerCode;
		
		// Add UTM and tracking parameters from cookies/data
		const trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'fbclid', 'gclid', 'msclkid', 'first_page_url'];
		trackingKeys.forEach(key => {
			let value = getCookie(key) || ischeduleData[key];
			if (value) {
				// Decode first_page_url to make it more readable
				if (key === 'first_page_url') {
					try {
						value = decodeURIComponent(value);
					} catch (e) {
						// If decoding fails, use the original value
						console.warn('Failed to decode first_page_url:', e);
					}
				}
				trackers[key] = value;
			}
		});

		// Set isVirtual flag
		ischeduleData.isVirtual = (ischeduleData.consultationType === 'virtual') ? '1' : '0';
		
		// Create unified API request object with all possible fields
		// API functions will destructure only the fields they need
		const apiRequestData = {
			bookingType: ischeduleData.bookingType || '',
			centerCode: ischeduleData.centerCode || '',
			apptDate: ischeduleData.apptDate || '',
			apptTime: ischeduleData.apptTime || '',
			apptId: ischeduleData.apptId || '',
			fname: ischeduleData.fname || '',
			lname: ischeduleData.lname || '',
			email: ischeduleData.email || '',
			dob: ischeduleData.dob || '',
			phone: ischeduleData.phone || '',
			areaCode: ischeduleData.areaCode || '',
			phoneNo: ischeduleData.phoneNo || '',
			isVirtual: ischeduleData.isVirtual || '',
			smsOptin: ischeduleData.smsOptin || '',
			zipCode: ischeduleData.zipCode || '',
			brand: ischeduleData.brand || '',
			IPaddress: ischeduleData.IPaddress || '',
			employeeRefId: ischeduleData.employeeRefId || '',
			clientToken: ischeduleData.clientToken || '',
			trackers: trackers || {},
			// isDev
			isDev: ischeduleData.isDev,
			// Honeypot 
			company_url: ischeduleData.company_url || '',
			// LCA tracking
			encSource: ischeduleData.encSource || '',
			did: ischeduleData.did || '',
			venid: ischeduleData.venid || '',
			subid: ischeduleData.subid || '',
			offerCode: ischeduleData.offerCode || '',
			eventid: ischeduleData.eventid || '',
			trans: ischeduleData.trans || '',
		};

		// Call appropriate API function based on bookingType
		// All functions will destructure only the fields they need from the unified object
		let apiCall;
		if (ischeduleData.bookingType === 'reschedule') {
			apiCall = reschedule(apiRequestData);
		} else if (ischeduleData.bookingType === 'schedulePreop') {
			apiCall = schedulePreop(apiRequestData);
		} else {
			// Default to bookAppt
			apiCall = bookAppt(apiRequestData);
		}

		// Send Slack notification with request data (using the same unified object)

		// sendSlackWebhookAlert(`🚀 iSchedule ${ischeduleData.bookingType} Payload`, {
		// 	request: apiRequestData,
		// 	timestamp: new Date().toISOString()
		// });

		apiCall
			.done(function(response) {
				//console.log('API response:', response);
				
				// Handle response similar to form_process.php
				if (response.success === 'true') {

					// Send Slack notification with response data
					// sendSlackWebhookAlert(`✅ iSchedule ${ischeduleData.bookingType} patientInfo`, {
					//  request: apiRequestData,
					// 	response: response.apiResponse.data.patientInfo,
					// 	timestamp: new Date().toISOString()
					// });
					
					// sendSlackWebhookAlert(`✅ iSchedule ${ischeduleData.bookingType} appointmentInfo`, {
					// 	request: apiRequestData,
					// 	response: response.apiResponse.data.appointmentInfo,
					// 	timestamp: new Date().toISOString()
					// });

					// Build redirect URL
					let redirectUrl = ischeduleData.confirmationUrl;
					
					// Get clientToken from response
					const clientToken = response.apiResponse?.data?.patientInfo?.clientToken || '';
					if (clientToken) {
						redirectUrl += '?clientToken=' + encodeURIComponent(clientToken);
					}
					
					// Check for rtcMeetingURL (Live Virtual)
					const rtcMeetingURL = response.apiResponse?.data?.appointmentInfo?.rtcMeetingURL;
					if (rtcMeetingURL) {
						redirectUrl = rtcMeetingURL;
					}
					
					// Redirect to confirmation page
					window.location.href = redirectUrl;

				} else {

					// Send Slack notification with response data
					// sendSlackWebhookAlert(`❌ iSchedule ${ischeduleData.bookingType} Error`, {
					// 	request: apiRequestData,
					// 	response: response,
					// 	timestamp: new Date().toISOString()
					// });

					// Handle errors
					const errorCode = response.apiResponse?.validationErrors?.[0]?.errorCode;
					
					if (errorCode === 'MATCH_FOUND') {
						// Handle MATCH_FOUND error
						console.error('MATCH_FOUND error');
						window.location.href = ischeduleData.errorUrl + '?error=MATCH_FOUND';
					} else if (errorCode === 'MULTIPLE_MATCH_MUST_CALL') {
						// Handle MULTIPLE_MATCH_MUST_CALL error
						console.error('MULTIPLE_MATCH_MUST_CALL error');
						window.location.href = ischeduleData.errorUrl + '?error=MULTIPLE_MATCH_MUST_CALL';
					} else {
						// Generic error
						console.error('Booking error:', response);
						window.location.href = ischeduleData.errorUrl;
					}

				}
			})
			.fail(function(err) {
				//console.error('API request failed:', err);

				// Check if this is a honeypot validation error
				if (err.responseJSON && err.responseJSON.code === 'honeypot_validation_failed') {
					// Show the display-error div on the form
					$('.display-error').text('Invalid submission detected. Please try again.').show();
					  
					// Hide spinner
					showForm();

					// Re-enable the submit button
					$('#isched_form button[type="submit"]').prop('disabled', false);
					return;
				}

				// Send Slack notification for failed API call
				sendSlackWebhookAlert(`❌ iSchedule ${ischeduleData.bookingType} Failed`, {
					request: apiRequestData,
					error: err,
					status: err.status,
					statusText: err.statusText,
					timestamp: new Date().toISOString()
				});

				error_redirect("API request failed: " + JSON.stringify(err));

			});
	}

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Zip Code Change

	let changeZipTippy;
	
	$(document).on('submit', '.isched_change_zip_form', function(e) {
		e.preventDefault();
		if ($(this).parsley().isValid()) {
			ischeduleData.zipCode = $(this).find('input[name="zip"]').val();
			populateZipValue(ischeduleData.zipCode);
			
			// Close the Tippy tooltip
			if (changeZipTippy && changeZipTippy[0]) {
				changeZipTippy[0].hide();
			}
			
			// Clear the zip input
			$(this).find('input[name="zip"]').val('');
			
			getCentersFromZip();
		}
	});


	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Start: Get My Location Button
	$(document).on('click', '.isched_start__geo_btn', function(e) {
		e.preventDefault();

		// Show loading state
		const $button = $(this);
		const originalContent = $button.html();
		$button.addClass('isched_start__geo_btn--loading').prop('disabled', true);

		getUserLocation()
			.then(coords => {
				//('Got user coordinates:', coords);
				return getZipCodeFromCoordinates(coords.lat, coords.lng);
			})
			.then(zipCode => {
				//console.log('Got zip code:', zipCode);
				// Populate the zip input field
				$('input[name="zip"]').val(zipCode).trigger('input');
				// Reset button state
				$button.html(originalContent).prop('disabled', false);
				$button.removeClass('isched_start__geo_btn--loading');
			})
			.catch(error => {
				console.error('Geolocation error:', error);
				alert(error.message);
				// Reset button state
				$button.html(originalContent).prop('disabled', false);
				$button.removeClass('isched_start__geo_btn--loading');
			});
	});

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Input masks

	// zip code
	$('input[name="zip"]').mask("00000");

    // dob
    $('input[name="dob"]').mask("00/00/0000");

	// us phone input mask
	$('input[name="phone"]').mask("(000) 000-0000");

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Email validation

	// Track email changes
	$('input[name="email"]').on('input', function() {
		email_changed = true;
	});

	// Parsley verifyemail validator
	window.Parsley.addValidator("verifyemail", {
		validateString: function(email) {
			if (!email_changed) {
				return true;
			}

			ischeduleData.email = email;

			// if (ischeduleData.isDev) {
			// 	console.log("verifyemail skipped in DEV");
			// 	return true;
			// }

			return verifyEmail(email).then(
				function(data) {
					//console.log("verifyemail response:", data);
					if (data.status != "invalid") {
						//console.log("verifyemail valid");
						email_changed = false;
						return true;
					} else {
						//console.log("verifyemail invalid");
						return $.Deferred().reject("Please enter a valid email address");
					}
				},
				function(error) {
					console.log("verifyemail error:", error);
					// Allow submission on API error (don't block user)
					return true;
				}
			);
		},
		messages: {
			en: "Please enter a valid email address"
		}
	});

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Phone validation

	// Track phone changes
	$('input[name="phone"]').on('input', function() {
		phone_changed = true;
	});

	// Parsley verifyphone validator
	window.Parsley.addValidator("verifyphone", {
		validateString: function(phone) {
			if (!phone_changed) {
				return true;
			}

			// Format phone: remove non-digits and leading 0 or 1
			const phone_formatted = phone.replace(/\D+/g, "").replace(/^[01]/, "");
			ischeduleData.phone = phone_formatted;
			ischeduleData.areaCode = phone_formatted.substr(0, 3);
			ischeduleData.phoneNo = phone_formatted.substr(3);

			// if (ischeduleData.isDev) {
			// 	console.log("verifyphone skipped in DEV");
			// 	return true;
			// }

			return verifyPhone(phone_formatted).then(
				function(data) {
					//console.log("verifyphone response:", data);
					if (data.status == "valid") {
						//console.log("verifyphone valid");
						phone_changed = false;
						return true;
					} else {
						//console.log("verifyphone invalid");
						return $.Deferred().reject("Please enter a valid phone number");
					}
				},
				function(error) {
					console.log("verifyphone error:", error);
					// Allow submission on API error (don't block user)
					return true;
				}
			);
		},
		messages: {
			en: "Please enter a valid phone number"
		}
	});

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Birthdate validation

	// Parsley birthdate validator
	window.Parsley.addValidator("birthdate", {
		validateString: function(value) {
			const birthDate = new Date(value);
			const today = new Date();
			const age = Math.floor((today - birthDate) / (365.25 * 24 * 60 * 60 * 1000));

			if (age >= 18) {
				return true;
			} else {
				return false;
			}
		},
		messages: {
			en: "You must be at least 18 years old"
		}
	});

	//////////////////////////////////////////////////////////////////////////////////////////////////
	////// Tippy
	const tooltips = initTooltips($);
	changeZipTippy = tooltips.changeZipTippy;

	  
});




